import { CHAM_CAROUSEL_OBSERVER_B } from '../experimentsEnum';
import { inExperiment } from '..';

export default (abTests) => inExperiment(CHAM_CAROUSEL_OBSERVER_B, abTests);
